module.exports = __webpack_public_path__ + "img/content7-7.9b06133c.webp";